import { IMAGES } from './images';

// Journal de l'atelier. Ordre d'affichage : du plus récent au plus ancien.
// Le contenu complet de chaque article vit dans src/pages/BlogPost.js (mêmes slugs).
const ALL_ARTICLES = [
  {
    slug: 'cinq-caracteres-cinq-facons-de-lire',
    published: false,
    title: 'Cinq caractères, cinq façons de lire',
    date: '30 août 2026',
    category: 'La collection',
    excerpt: "Sylvette relit, Léon ronchonne, Pralin s'enthousiasme, Pépin conteste, Camille écoute. Cinq compagnons de lecture, et cinq manières bien réelles de tenir un livre.",
    readTime: '5 min',
    img: IMAGES.journalCollection,
  },
  {
    slug: 'le-rituel-du-soir',
    published: false,
    title: 'Le rituel du soir : lire moins vite',
    date: '26 août 2026',
    category: 'Rituels',
    excerpt: "Trois pages lues lentement valent mieux que trente pages traversées. Petit éloge de la lecture du soir et du livre qu'on referme proprement.",
    readTime: '4 min',
    img: IMAGES.journalRituel,
  },
  {
    slug: 'anatomie-d-une-piece',
    published: false,
    title: "Anatomie d'une pièce : du minkee à la dernière couture",
    date: '21 août 2026',
    category: 'Matières',
    excerpt: "Le minkee, le coton imprimé du dos, le fil, le visage brodé, la couture main. Tout ce qui se passe entre le coupon de tissu et la pièce qui part dans un livre.",
    readTime: '5 min',
    img: IMAGES.journalAtelier,
  },
  {
    slug: 'pourquoi-on-perd-sa-page',
    published: false,
    title: 'Pourquoi on perd toujours sa page',
    date: '16 août 2026',
    category: 'Lecture',
    excerpt: "Le ticket de caisse, le coin plié, le livre posé ouvert à plat. Petit inventaire des solutions provisoires du lecteur distrait, et de ce qu'elles coûtent vraiment.",
    readTime: '4 min',
    img: IMAGES.journalPage,
  },
  {
    slug: 'le-placard-d-ou-vient-le-nom',
    title: "Le placard : d'où vient le nom",
    date: '11 août 2026',
    category: "L'atelier",
    excerpt: "Avant d'être une marque, Le Placard à Doudous était un meuble, dans une chambre d'enfant, rempli à ras bord. Voici comment il est devenu un atelier.",
    readTime: '4 min',
    img: IMAGES.journalPlacard,
    en: {
      title: 'The cupboard: where the name comes from',
      date: '11 August 2026',
      category: 'The workshop',
      excerpt: 'Before it was a brand, Le Placard à Doudous was a piece of furniture in a child’s bedroom, filled to the brim. Here is how it became a workshop.',
    },
  },
];

// Version anglaise d'un article quand elle existe ; categoryKey garde la catégorie française
// (clé des couleurs de badge). Un article sans traduction reste en français.
export function localizeArticle(article, locale) {
  if (!article) return article;
  const translated = locale === 'en' && article.en ? article.en : {};
  return { ...article, ...translated, categoryKey: article.category };
}

// Articles en cours de réécriture : passer published à true (ou retirer la ligne) pour les republier.
export const ARTICLES = ALL_ARTICLES.filter(article => article.published !== false);
